import type { FaireProductEntity } from "../../entity_types/product";

export const p_a4j6hrv2jp: FaireProductEntity = {
  token: "p_a4j6hrv2jp",
  type: "product",
  name: "Dinosaur Sweater - Boys Clothing - Fall/Winter",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/ddcc13e6862cc5505a7dc40cfe34dda0a8f160ec6dbbc882f1af2f5832e3c5a8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5dd1af9725787dec75b78759500fd4e5b8e77d710454e7f4286ae720a077922a.jpeg",
    "https://cdn.faire.com/fastly/244afea1690054ac7088f6982f52bf5a9a441ff44b2ff71bc73176da7e42364e.jpeg",
    "https://cdn.faire.com/fastly/1102d818c6cac6e3178be6fa7e2a205ff97cf80be17b9fd54a2651c42510d285.jpeg",
  ],
  priceDollars: 32,
  description:
    "Soft, cozy, and a little prehistoric fun, this sweater adds a playful dino touch to chilly day layering and everyday exploring.\n\nFeatures:\n * Sweater Color: Light Grey \n * Material: 50% Viscose, 30% Polyester, 20% Nylon \n * Fit: True to size \n * Care: Hand wash only, do not iron, tumble dry, bleach or dry clean \n\nEach sweater is packed with love in our hometown warehouse.",
  tags: [],
  msrpDollars: 64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:19.560Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
